import { logger } from "./logger";
import { reconnect, getAccount, watchAccount } from "wagmi/actions";
import { COINBASE_WALLET_RDNS, wagmiConfig } from "./wagmi";

/**
 * Mobile wallet reconnection helper
 * Detects when wallet connection is established after returning from mobile wallet app
 */

let isListening = false;
let reconnectTimeout: NodeJS.Timeout | undefined;
let wasDisconnected = false;

export function initMobileWalletReconnect() {
  if (isListening) return;

  const isMobile =
    /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
      navigator.userAgent.toLowerCase(),
    );

  if (!isMobile) return;

  isListening = true;

  watchAccount(wagmiConfig(), {
    onChange(account) {
      if (wasDisconnected && account.isConnected && account.address) {
        wasDisconnected = false;
        window.dispatchEvent(new CustomEvent("wallet-connected"));
      }
    },
  });

  document.addEventListener("visibilitychange", async () => {
    if (!document.hidden) {
      const currentAccount = getAccount(wagmiConfig());
      if (!currentAccount.isConnected) {
        wasDisconnected = true;
      }

      if (reconnectTimeout) {
        clearTimeout(reconnectTimeout);
      }

      reconnectTimeout = setTimeout(async () => {
        try {
          const config = wagmiConfig();
          await reconnect(config, {
            connectors: config.connectors.filter(
              (c) => c.id !== COINBASE_WALLET_RDNS,
            ),
          });
        } catch (error) {
          logger.info(`[MobileReconnect] Reconnect failed: ${error}`);
        }
      }, 500);
    }
  });

  logger.info("[MobileReconnect] Initialized");
}
